import { useEffect, useState } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";

import { Grid } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";

import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
// import AddIcon from "@mui/icons-material/Add";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DeleteIcon from "@mui/icons-material/Delete";

import { updateShippingOrder } from "src/api/shippingOrder";

import font from "src/styles/font";
import device from "src/styles/device";
import { checkNotEmpty } from "src/common";
import {
  Black,
  DarkGrey,
  Grey,
  GreyStroke,
  Primary,
  White01,
} from "src/styles/color";
import { renameFile as commonRename } from "src/common/file";

import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import TextField from "src/components/core/TextField";
import UploadPdf from "src/components/upload/dropzone/UploadPdf";
// import UploadImage from "src/components/upload/dropzone/UploadImage";
import UploadMultiImage from "src/components/upload/dropzone/UploadMultiImage";

import { SpanLabel } from "src/modules/order/shipping-order/components";

const CloseButton = styled(IconButton)`
  &.MuiIconButton-root {
    color: ${Black};
  }
`;

const StyledDialog = muiStyled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 16,
  },
  "& .MuiDialogContent-root": {
    maxHeight: "500px",
    border: 0,
    padding: 24,
    paddingTop: 0,
  },
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: 640,
    },
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
  "& .MuiDialogActions-root>:not(:first-of-type)": {
    marginLeft: 24,
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiPaper-root": {
      margin: 24,
    },
    "& .MuiDialogContent-root": {
      padding: 16,
      paddingTop: 0,
    },
    "& .MuiDialogActions-root": {
      padding: 16,
    },
  },
}));

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d8d8dc;
  margin: 24px 0;
`;

const SpanTitle = styled.div`
  font-size: ${font.size.md};
  font-weight: ${({ slim }) => (slim ? "400" : "600")};
  line-height: 24px;
  margin: ${({ slim, unMargin }) => slim && !unMargin && "auto"};

  @media ${device.mobileL} {
    font-size: ${font.size.sm};
  }
`;

const StyledTextField = styled(TextField)`
  .MuiInputBase-adornedEnd {
    padding-right: 2px;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  .MuiOutlinedInput-root {
    padding-right: 12px;
  }
  &.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${DarkGrey};
  }
  .Mui-disabled,
  &.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: ${GreyStroke};
  }
`;

const Dragger = styled.div`
  width: 100%;
  padding: 24px 16px;
  position: relative;
  /* display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; */
  border-radius: 16px;
  border: 1px dashed ${GreyStroke};
  text-align: center;
  background-color: #faf9f9;

  &:hover {
    border: 1px dashed ${Primary};
    cursor: pointer;
  }

  @media ${device.mobileL} {
    padding: 16px;
    border-radius: 8px;
  }
`;

const WrapperIconUpload = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 8px 8px;
  margin: 0 auto;
  background-color: ${White01};
`;

const TextDragger = styled.p`
  width: 100%;
  margin: 4px 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: ${DarkGrey};

  span {
    font-size: 0.875rem;
    font-weight: 600;
    color: ${Black};
  }

  :first-of-type {
    margin-top: 12px;
  }

  @media ${device.mobileL} {
    font-size: 0.75rem;
  }
`;

const UploadItem = styled.div`
  width: 100%;
  padding: 12px;
  border: 1px solid ${Grey};
  border-radius: 16px;

  @media ${device.mobileL} {
    padding: 8px;
    border-radius: 8px;
  }
`;

const PreviewImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;

  @media ${device.mobileL} {
    width: 60px;
    height: 60px;
    border-radius: 4px;
  }
`;

const PreviewImageTitle = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  line-height: 24px;
  color: Black;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: normal;

  @media ${device.mobileL} {
    font-size: ${font.size.sm};
  }
`;

// const WrapperUploadImage = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const WrapperImgSlip = styled.div`
//   width: 100%;
//   padding: 20px 100px;
//   border: 1px dashed #e13b30;
//   border-radius: 16px;
//   height: auto;
// `;

// const ImgSlip = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: contain;
// `;

const ShippedDialog = ({ onClose, onSuccess, orderDetail, setIsLoading }) => {
  const { enqueueSnackbar } = useSnackbar();

  const initialDetail = {
    order: null,
    method: "ส่งไปถึงลูกค้าโดยตรง",
    fulfillmentProcess: [
      {
        type: "มีค่าจัดส่ง",
        carrier: "จัดส่งโดยร้านค้า",
        trackingNumber: null,
        trackingUrl: null,
        shippingFee: null,
        pickupAddress: {
          name: null,
          tel: null,
          address: null,
          coordinates: {
            lat: null,
            lng: null,
          },
        },
        shippingProofs: [],
        deliveryProofs: [],
        shippedDate: null,
        estimatedDeliveryDate: null,
        actualDeliveryDate: null,
        remark: null,
      },
    ],
    payment: {
      method: null,
      info: {
        bankAccountName: null,
        bankNo: null,
      },
      total: null,
      paymentDate: null,
      paymentProof: null,
    },
    status: {
      failureReason: null,
      value: "pending",
    },
    note: null,
    documents: {
      customer: {
        qt: {
          qtDate: null,
          qtNo: null,
          customerQtFile: null,
          customerQtAdditionalFile: null,
        },
        inv: {
          invDate: null,
          invNo: null,
          customerInvFile: null,
          customerInvAdditionalFile: null,
        },
      },
      xsurface: {
        po: {
          poDate: null,
          poNo: null,
          xsurfacePoFile: null,
          xsurfacePoAdditionalFile: null,
        },
        vc: {
          vcDate: null,
          vcNo: null,
          xsurfaceVcFile: null,
          xsurfaceVcAdditionalFile: null,
        },
      },
      seller: {
        qt: {
          qtDate: null,
          qtNo: null,
          sellerQtFile: null,
          sellerQtAdditionalFile: null,
        },
        inv: {
          invDate: null,
          invNo: null,
          sellerInvFile: null,
          sellerInvAdditionalFile: null,
        },
      },
    },
  };

  const [shippingDetail, setShippingDetail] = useState(initialDetail);

  const isJSONString = (str) => {
    if (typeof str !== "string") return str;
    try {
      return JSON.parse(str);
    } catch {
      return str;
    }
  };

  useEffect(() => {
    if (!!orderDetail) {
      setShippingDetail((order) => ({
        ...order,
        ...orderDetail,
        method: orderDetail.method
          ? isJSONString(orderDetail.method)
          : "ส่งไปถึงลูกค้าโดยตรง",
        fulfillmentProcess:
          orderDetail.fulfillmentProcess.length > 0
            ? orderDetail.fulfillmentProcess
            : initialDetail.fulfillmentProcess,
        payment: orderDetail.payment,
        documents: orderDetail.documents,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail]);

  const renameFile = (file) => {
    const randomPart = Math.floor(Math.random() * 100000);
    let newName = `INVSL${dayjs().format("DDMMYY")}-${randomPart}`;
    return new File([file], newName, {
      type: file.type,
      lastModified: file.lastModified,
    });
  };

  const handleDeleteImg = (imgIndex) => {
    setShippingDetail((prevState) => {
      const updateShipping = [...prevState.fulfillmentProcess];
      const updateShippingProof = [...updateShipping[0].shippingProofs];

      updateShippingProof.splice(imgIndex, 1);

      updateShipping[0] = {
        ...updateShipping[0],
        ...{ shippingProofs: updateShippingProof },
      };
      return {
        ...prevState,
        fulfillmentProcess: updateShipping,
      };
    });
  };

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const payload = {
        ...shippingDetail,
        status: {
          value: "shipped",
        },
        order: orderDetail?.order?._id,
      };
      delete payload.orderDetail;

      const data = new FormData();
      for (const field in payload) {
        if (
          field === "order" ||
          field === "_id" ||
          field === "method" ||
          field === "note" ||
          field === "seller"
        ) {
          data.append(field, payload[field]);
        } else {
          data.append(field, JSON.stringify(payload[field]));
        }
      }

      let document = JSON.parse(data.get("documents"));
      delete document.seller.inv.sellerInvFile;
      delete document.seller.inv.sellerInvAdditionalFile;
      data.set("documents", JSON.stringify(document));

      if (
        typeof payload.documents.seller.inv.sellerInvFile === "object" &&
        payload.documents.seller.inv.sellerInvFile !== null
      ) {
        if (payload.documents.seller.inv.sellerInvFile?.path) {
          data.append(
            `document.seller.in.sellerInvFile`,
            renameFile(payload.documents.seller.inv.sellerInvFile),
          );
        } else {
          document.seller.inv.sellerInvFile =
            payload.documents.seller.inv.sellerInvFile._id;
          data.set("documents", JSON.stringify(document));
        }
      }

      if (
        typeof payload.documents.seller.inv.sellerInvAdditionalFile ===
          "object" &&
        payload.documents.seller.inv.sellerInvAdditionalFile !== null
      ) {
        if (payload.documents.seller.inv.sellerInvAdditionalFile?.path) {
          data.append(
            `document.seller.inv.sellerInvAdditionalFile`,
            renameFile(payload.documents.seller.inv.sellerInvAdditionalFile),
          );
        } else {
          document.seller.inv.sellerInvAdditionalFile =
            payload.documents.seller.inv.sellerInvAdditionalFile._id;
          data.set("documents", JSON.stringify(document));
        }
      }

      if (payload?.fulfillmentProcess[0]?.shippingProofs?.length > 0) {
        payload?.fulfillmentProcess[0]?.shippingProofs?.map((item, index) =>
          data.append(
            `fulfillmentProcess.0.shippingProofs.${index}.shippingProof`,
            commonRename(item, "SHP"),
          ),
        );
      }
      // if (payload.fulfillmentProcess[0]?.shippingProofs)
      //   data.append(
      //     "fulfillmentProcess.0.shippingProofs",
      //     payload.fulfillmentProcess[0].shippingProofs,
      //   );
      delete data.documents;

      let fulfillmentProcess = JSON.parse(data.get("fulfillmentProcess"));
      if (fulfillmentProcess?.[0]?.deliveryProofs?.length > 0) {
        let formatDeliveryProofs = fulfillmentProcess?.[0]?.deliveryProofs;

        formatDeliveryProofs?.map((item, index) => {
          let format = item;
          format.deliveryProof = item?.deliveryProof?._id;
          return format;
        });

        fulfillmentProcess[0] = {
          ...fulfillmentProcess[0],
          ...{ deliveryProofs: formatDeliveryProofs },
        };
      }
      delete fulfillmentProcess[0]?.shippingProofs;
      data.set("fulfillmentProcess", JSON.stringify(fulfillmentProcess));

      await updateShippingOrder(shippingDetail._id, data);
      await onSuccess();
      enqueueSnackbar(`อัพเดทรายละเอียดการจัดส่งสินค้า สำเร็จ`, {
        variant: "success",
      });
    } catch (err) {
      console.error("err:", err);
      enqueueSnackbar(err?.response?.data?.message, {
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const validateField = () => {
    if (
      shippingDetail?.fulfillmentProcess?.[0]?.shippedDate
      // && shippingDetail?.fulfillmentProcess?.[0]?.shippingProofs &&
      // shippingDetail?.documents?.seller?.inv?.invDate &&
      // shippingDetail?.documents?.seller?.inv?.invNo &&
      // shippingDetail?.documents?.seller?.inv?.sellerInvFile
    )
      return false;
    else return true;
  };

  return (
    <StyledDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
    >
      <DialogTitle
        sx={{
          p: {
            sm: 3,
            xs: 2,
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          fontSize: {
            sm: font.size.lg,
            xs: font.size.md,
          },
          fontWeight: 600,
        }}
      >
        ส่งสินค้า
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </CloseButton>
      </DialogTitle>

      <DialogContent>
        <Grid container xs={12}>
          <Grid item xs={12}>
            <SpanLabel isMargin>
              วันที่ส่งสินค้าออกจากคลัง <span>*</span>
            </SpanLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <StyledDatePicker
                inputFormat="DD-MM-YYYY"
                value={shippingDetail?.fulfillmentProcess[0]?.shippedDate}
                onChange={(value) => {
                  setShippingDetail((prevState) => {
                    const updateShipping = [...prevState.fulfillmentProcess];
                    updateShipping[0] = {
                      ...updateShipping[0],
                      ...{ shippedDate: value.$d },
                    };
                    return {
                      ...prevState,
                      fulfillmentProcess: updateShipping,
                    };
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{
                      width: "100%",
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>

        <Grid container spacing={1} xs={12} mt={2}>
          <Grid item xs={12}>
            <SpanLabel>
              รูปที่ส่งให้ลูกค้า <span>(สูงสุด 3 รูป)</span>
            </SpanLabel>
          </Grid>

          <Grid item xs={12}>
            {/* <UploadImage
              callBackFile={(fileCallBlack) => {
                fileCallBlack !== "" &&
                  setShippingDetail((prevState) => {
                    const updateShipping = [...prevState.fulfillmentProcess];
                    updateShipping[0] = {
                      ...updateShipping[0],
                      ...{ shippingProof: fileCallBlack },
                    };
                    return {
                      ...prevState,
                      fulfillmentProcess: updateShipping,
                    };
                  });
              }}
              closeAlert={false}
            >
              {checkNotEmpty(
                shippingDetail?.fulfillmentProcess[0]?.shippingProof,
              ) ? (
                <WrapperUploadImage>
                  <WrapperImgSlip>
                    <ImgSlip
                      src={
                        shippingDetail?.fulfillmentProcess[0]?.shippingProof
                          .fileData
                      }
                      alt="paySlipImage"
                    />
                  </WrapperImgSlip>
                </WrapperUploadImage>
              ) : (
                <WrapperUploadImage>
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<AddIcon />}
                    sx={{ width: "100%" }}
                  >
                    แนบรูปสินค้า
                  </Button>
                </WrapperUploadImage>
              )}
            </UploadImage> */}
            <UploadMultiImage
              callBackFile={(fileCallBlack) => {
                fileCallBlack !== "" &&
                  setShippingDetail((prevState) => {
                    const updateShipping = [...prevState.fulfillmentProcess];
                    let updateShippingProof = [
                      ...(updateShipping[0].shippingProofs || []),
                    ];

                    if (
                      updateShipping[0].shippingProofs?.length +
                        fileCallBlack?.length >
                      3
                    ) {
                      enqueueSnackbar(`Number of files is more than 3.`, {
                        variant: "error",
                      });
                    } else {
                      updateShippingProof = [
                        ...updateShippingProof,
                        ...fileCallBlack,
                      ];
                    }

                    updateShipping[0] = {
                      ...updateShipping[0],
                      ...{ shippingProofs: updateShippingProof },
                    };
                    return {
                      ...prevState,
                      fulfillmentProcess: updateShipping,
                    };
                  });
              }}
              closeAlert={false}
              limitFile={3}
              isDisabled={
                shippingDetail?.fulfillmentProcess?.[0]?.shippingProofs
                  ?.length >= 3
              }
            >
              <Dragger>
                <WrapperIconUpload>
                  <FileUploadIcon sx={{ color: Black }} />
                </WrapperIconUpload>
                <TextDragger>
                  <span>กดเพื่ออัปโหลด</span> หรือลากวาง
                </TextDragger>
                <TextDragger>jpg, png, jpeg</TextDragger>
                <TextDragger>(Max. File size: 4 MB)</TextDragger>
              </Dragger>
            </UploadMultiImage>
          </Grid>

          {checkNotEmpty(
            shippingDetail?.fulfillmentProcess?.[0]?.shippingProofs,
          ) && (
            <Grid item xs={12} container spacing={1}>
              {shippingDetail?.fulfillmentProcess?.[0]?.shippingProofs.map(
                (img, index) => (
                  <Grid item xs={12}>
                    <UploadItem>
                      <Grid
                        container
                        spacing={{ xs: 1, md: 2 }}
                        alignItems="center"
                      >
                        <Grid
                          item
                          xs="auto"
                          sx={{
                            maxHeight: { xs: "68px", sm: "88px", md: "96px" },
                          }}
                        >
                          <PreviewImage
                            src={img?.fileData}
                            alt={`shippingProof-${index}`}
                          />
                        </Grid>

                        <Grid item xs>
                          <PreviewImageTitle>{img?.path}</PreviewImageTitle>
                        </Grid>

                        <Grid item xs="auto">
                          <IconButton onClick={() => handleDeleteImg(index)}>
                            <DeleteIcon sx={{ color: Grey }} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </UploadItem>
                  </Grid>
                ),
              )}
            </Grid>
          )}
        </Grid>

        <Line />

        <Grid container xs={12} mb={2}>
          <SpanTitle>เอกสาร</SpanTitle>
        </Grid>

        <Grid container xs={12}>
          <Grid item xs={6} pr={2}>
            <SpanLabel isMargin>
              {`วันที่ ใบเสร็จ/ใบกำกับภาษี (ของร้านค้า)`}
            </SpanLabel>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <StyledDatePicker
                inputFormat="DD/MM/YYYY"
                value={shippingDetail?.documents?.seller?.inv?.invDate}
                onChange={(value) => {
                  const newValue = shippingDetail;
                  newValue.documents.seller.inv.invDate = value.$d;
                  setShippingDetail({ ...newValue });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    sx={{
                      // my: 2,
                      width: "100%",
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} pl={2}>
            <SpanLabel isMargin>
              {`ใบเสร็จ/ใบกำกับภาษี No. (ของร้านค้า)`}
            </SpanLabel>
            <TextField
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={shippingDetail?.documents?.seller?.inv?.invNo}
              onChange={({ target }) => {
                const newValue = shippingDetail;
                newValue.documents.seller.inv.invNo = target.value;
                setShippingDetail({ ...newValue });
              }}
            />
          </Grid>
        </Grid>

        <Grid container xs={12} mt={2}>
          <Grid item xs={12}>
            <SpanLabel isMargin>{`ใบเสร็จ/ใบกำกับภาษี (ของร้านค้า)`}</SpanLabel>
            <StyledTextField
              variant="outlined"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <>
                    {/* additionalFile */}
                    {checkNotEmpty(
                      shippingDetail?.documents?.seller?.inv?.sellerInvFile,
                    ) ? (
                      <IconButton
                        onClick={() => {
                          const newShipping = shippingDetail;
                          shippingDetail.documents.seller.inv.sellerInvFile =
                            "";
                          setShippingDetail({ ...newShipping });
                        }}
                      >
                        <DeleteOutlineIcon
                          sx={{
                            color: Primary,
                            cursor: "pointer",
                          }}
                        />
                      </IconButton>
                    ) : (
                      <UploadPdf
                        callBackFile={(fileCallBlack) => {
                          const newShipping = shippingDetail;
                          newShipping.documents.seller.inv.sellerInvFile =
                            fileCallBlack;
                          setShippingDetail({ ...newShipping });
                        }}
                        closeAlert={false}
                      >
                        <IconButton>
                          <AttachFileIcon
                            sx={{
                              color: Black,
                              cursor: "pointer",
                              fontSize: font.size.lg,
                              ":hover": {
                                color: "#e04132",
                              },
                            }}
                          />
                        </IconButton>
                      </UploadPdf>
                    )}
                  </>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              value={
                typeof shippingDetail?.documents?.seller?.inv?.sellerInvFile !==
                "object"
                  ? shippingDetail?.documents?.seller?.inv?.sellerInvFile
                  : !!shippingDetail?.documents?.seller?.inv?.sellerInvFile
                        ?.docUrl
                    ? shippingDetail?.documents?.seller?.inv?.sellerInvFile
                        ?.originalFileName
                    : shippingDetail?.documents?.seller?.inv?.sellerInvFile
                        ?.name
              }
            />
          </Grid>
        </Grid>

        <Grid container xs={12} mt={2}>
          <Grid item xs={12}>
            <SpanLabel isMargin>{`เอกสารเพิ่มเติม`}</SpanLabel>
            <StyledTextField
              variant="outlined"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <>
                    {checkNotEmpty(
                      shippingDetail?.documents?.seller?.inv
                        ?.sellerInvAdditionalFile,
                    ) ? (
                      <IconButton
                        onClick={() => {
                          const newShipping = shippingDetail;
                          shippingDetail.documents.seller.inv.sellerInvAdditionalFile =
                            "";
                          setShippingDetail({ ...newShipping });
                        }}
                      >
                        <DeleteOutlineIcon
                          sx={{
                            color: Primary,
                            cursor: "pointer",
                          }}
                        />
                      </IconButton>
                    ) : (
                      <UploadPdf
                        callBackFile={(fileCallBlack) => {
                          const newShipping = shippingDetail;
                          newShipping.documents.seller.inv.sellerInvAdditionalFile =
                            fileCallBlack;
                          setShippingDetail({ ...newShipping });
                        }}
                        closeAlert={false}
                      >
                        <IconButton>
                          <AttachFileIcon
                            sx={{
                              color: Black,
                              cursor: "pointer",
                              fontSize: font.size.lg,
                              ":hover": {
                                color: "#e04132",
                              },
                            }}
                          />
                        </IconButton>
                      </UploadPdf>
                    )}
                  </>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              value={
                typeof shippingDetail?.documents?.seller?.inv
                  ?.sellerInvAdditionalFile !== "object"
                  ? shippingDetail?.documents?.seller?.inv
                      ?.sellerInvAdditionalFile
                  : !!shippingDetail?.documents?.seller?.inv
                        ?.sellerInvAdditionalFile?.docUrl
                    ? shippingDetail?.documents?.seller?.inv
                        ?.sellerInvAdditionalFile?.originalFileName
                    : shippingDetail?.documents?.seller?.inv
                        ?.sellerInvAdditionalFile?.name
              }
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          onClick={() => onClose()}
          fullWidth
          sx={{ maxWidth: 180 }}
        >
          ยกเลิก
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit()}
          fullWidth
          sx={{ maxWidth: 180 }}
          disabled={validateField()}
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default ShippedDialog;
